import { PlaceInNestedAkixiNameSpace } from '../utils/Utils'

export const iREPORT_VALUE_ALARM_SOUND_TYPE_NONE = -1 // Default alarm sound type.
export const iREPORT_VALUE_ALARM_REPEAT_TYPE_ONCE = -1 // Alarm repeat type - default - alarm only sounds once
export const iREPORT_VALUE_ALARM_REPEAT_TYPE_SECONDS = 1 // Alarm repeat type - seconds.
export const iREPORT_VALUE_ALARM_REPEAT_TYPE_PERSISTENT = 2 // Alarm repeat type - persistent.
export const iREPORT_VALUE_ALARM_REPEAT_TYPE_REPEAT_N_TIMES = 3 // Alarm repeat type - repeat n times.
export const iREPORT_VALUE_ALARM_SETTINGS_VALUE_NONE = 0 // Alarm settings value type.

export const sXML_CONTENT_BODY_ALARM_ACTIONS_TAG = 'AlarmActions'
export const sXML_CONTENT_BODY_ALARM_ACTIONS_ATTRIB_COUNT = 'Count'
export const sXML_CONTENT_BODY_ALARM_ACTION_TAG = 'AlarmAction'
export const sXML_CONTENT_BODY_ALARM_ACTION_ATTRIB_STAT_ID = 'StatID'
export const sXML_CONTENT_BODY_ALARM_ACTION_ATTRIB_SOUND_TYPE = 'SoundType'
export const sXML_CONTENT_BODY_ALARM_ACTION_ATTRIB_REPEAT_TYPE = 'RepeatType'
export const sXML_CONTENT_BODY_ALARM_ACTION_ATTRIB_VALUE = 'Value'

export interface ISoundInfo {
    sFilename: string
    sDescription: string
    iDuration: number
}
export const pFIELD_ALARM_SOUNDS: ISoundInfo[] = [
    {
        sFilename: 'Air Raid Siren.wav',
        sDescription: 'Air Raid Siren',
        iDuration: 8.0
    },
    {
        sFilename: 'Alarm Clock.wav',
        sDescription: 'Alarm Clock',
        iDuration: 3.0
    },
    {
        sFilename: 'Ding.wav',
        sDescription: 'Ding',
        iDuration: 2.0
    },
    {
        sFilename: 'Door Chime.wav',
        sDescription: 'Door Chime',
        iDuration: 3.0
    },
    {
        sFilename: 'Emergency Services.wav',
        sDescription: 'Emergency Services',
        iDuration: 4.0
    },
    {
        sFilename: 'Fasten Seat Belt.wav',
        sDescription: 'Fasten Seat Belt',
        iDuration: 2.0
    },
    {
        sFilename: 'Kerching.wav',
        sDescription: 'Kerching',
        iDuration: 2.0
    },
    {
        sFilename: 'Phone.wav',
        sDescription: 'Phone',
        iDuration: 3.0
    },
    {
        sFilename: 'Quick Bleep.wav',
        sDescription: 'Quick Bleep',
        iDuration: 1.0
    },
    {
        sFilename: 'Radar.wav',
        sDescription: 'Radar',
        iDuration: 3.0
    },
    {
        sFilename: 'Sonar Ping.wav',
        sDescription: 'Sonar Ping',
        iDuration: 4.0
    },
    {
        sFilename: 'Target.wav',
        sDescription: 'Target',
        iDuration: 4.0
    },
    {
        sFilename: 'Ting.wav',
        sDescription: 'Ting',
        iDuration: 3.0
    },
    {
        sFilename: 'Warning Beep.wav',
        sDescription: 'Warning Beep',
        iDuration: 1.0
    },
    {
        sFilename: 'Warning Buzzer.wav',
        sDescription: 'Warning Buzzer',
        iDuration: 2.0
    },
    {
        sFilename: 'Barking.wav',
        sDescription: 'Barking',
        iDuration: 5.0
    },
    {
        sFilename: 'Birds.wav',
        sDescription: 'Birds',
        iDuration: 2.0
    },
    {
        sFilename: 'Cat.wav',
        sDescription: 'Cat',
        iDuration: 2.0
    },
    {
        sFilename: 'Chips.wav',
        sDescription: 'Chips',
        iDuration: 1.0
    },
    {
        sFilename: 'Coin Drop.wav',
        sDescription: 'Coin Drop',
        iDuration: 2.0
    },
    {
        sFilename: 'Computer.wav',
        sDescription: 'Computer',
        iDuration: 5.0
    },
    {
        sFilename: 'Cow.wav',
        sDescription: 'Cow',
        iDuration: 1.0
    },
    {
        sFilename: 'Crowd.wav',
        sDescription: 'Crowd',
        iDuration: 6.0
    },
    {
        sFilename: 'Dial Tone.wav',
        sDescription: 'Dial Tone',
        iDuration: 1.0
    },
    {
        sFilename: 'Dixie Horn.wav',
        sDescription: 'Dixie Horn',
        iDuration: 2.0
    },
    {
        sFilename: 'Fire Truck.wav',
        sDescription: 'Fire Truck',
        iDuration: 4.0
    },
    {
        sFilename: 'Gunshot.wav',
        sDescription: 'Gunshot',
        iDuration: 1.0
    },
    {
        sFilename: 'Hammer.wav',
        sDescription: 'Hammer',
        iDuration: 4.0
    },
    {
        sFilename: 'Helicopter.wav',
        sDescription: 'Helicopter',
        iDuration: 5.0
    },
    {
        sFilename: 'Ice Cubes.wav',
        sDescription: 'Ice Cubes',
        iDuration: 1.0
    },
    {
        sFilename: 'Laughter.wav',
        sDescription: 'Laughter',
        iDuration: 6.0
    },
    {
        sFilename: 'Marbles.wav',
        sDescription: 'Marbles',
        iDuration: 5.0
    },
    {
        sFilename: 'Monkey.wav',
        sDescription: 'Monkey',
        iDuration: 4.0
    },
    {
        sFilename: 'Morse Code.wav',
        sDescription: 'Morse Code',
        iDuration: 2.0
    },
    {
        sFilename: 'Nighttime.wav',
        sDescription: 'Night Time',
        iDuration: 7.0
    },
    {
        sFilename: 'Owl.wav',
        sDescription: 'Owl',
        iDuration: 2.0
    },
    {
        sFilename: 'Pool.wav',
        sDescription: 'Pool',
        iDuration: 1.0
    },
    {
        sFilename: 'Poring Water.wav',
        sDescription: 'Pouring Water',
        iDuration: 5.0
    },
    {
        sFilename: 'Relaod.wav',
        sDescription: 'Reload',
        iDuration: 1.0
    },
    {
        sFilename: 'Rocks Falling.wav',
        sDescription: 'Rocks Falling',
        iDuration: 1.0
    },
    {
        sFilename: 'Rooster.wav',
        sDescription: 'Rooster',
        iDuration: 2.0
    },
    {
        sFilename: 'Sawing.wav',
        sDescription: 'Sawing',
        iDuration: 5.0
    },
    {
        sFilename: 'School bell.wav',
        sDescription: 'School Bell',
        iDuration: 6.0
    },
    {
        sFilename: 'Seaguls.wav',
        sDescription: 'Seaguls',
        iDuration: 7.0
    },
    {
        sFilename: 'Service Bell.wav',
        sDescription: 'Service Bell',
        iDuration: 1.0
    },
    {
        sFilename: 'SMS.wav',
        sDescription: 'SMS',
        iDuration: 2.0
    },
    {
        sFilename: 'Splash.wav',
        sDescription: 'Splash',
        iDuration: 2.0
    },
    {
        sFilename: 'Steam Train.wav',
        sDescription: 'Steam Train',
        iDuration: 5.0
    },
    {
        sFilename: 'Submarine.wav',
        sDescription: 'Submarine',
        iDuration: 4.0
    },
    {
        sFilename: 'Thunder.wav',
        sDescription: 'Thunder',
        iDuration: 7.0
    },
    {
        sFilename: 'Tolling Bell.wav',
        sDescription: 'Tolling Bell',
        iDuration: 10.0
    },
    {
        sFilename: 'Trombone.wav',
        sDescription: 'Trombone',
        iDuration: 4.0
    },
    {
        sFilename: 'Twinkle.wav',
        sDescription: 'Twinkle',
        iDuration: 10.0
    },
    {
        sFilename: 'Walking.wav',
        sDescription: 'Walking',
        iDuration: 5.0
    },
    {
        sFilename: 'Whistling.wav',
        sDescription: 'Whistling',
        iDuration: 4.0
    }
]

// Place at com.Akixi.Alarming.pAlarmSounds
PlaceInNestedAkixiNameSpace('Alarming', 'pAlarmSounds', pFIELD_ALARM_SOUNDS)
